/**
 * Parses Shopware's dynamic URL format (from sw-dynamic-url-field) to PWA-compatible URLs
 *
 * Shopware's dynamic URL format example:
 * "124c71d524604ccbad6042edce3ac799/navigation/7ca4dc78a49d4363b40e24e560fdadf2#"
 *
 * This function extracts the entity type and ID to create proper PWA routes:
 * - Navigation (category) URLs: "/navigation/{categoryId}"
 * - Regular URLs are returned as-is
 *
 * @param {string | null | undefined} url - The URL to parse (from CMS element config)
 * @return {string | null} - The parsed URL ready for PWA routing, or null if input is empty
 *
 * Example usage:
 * parseDynamicUrl("124c71d524604ccbad6042edce3ac799/navigation/7ca4dc78a49d4363b40e24e560fdadf2#")
 * Returns: "/navigation/7ca4dc78a49d4363b40e24e560fdadf2"
 *
 * parseDynamicUrl("https://external.com/page")
 * Returns: "https://external.com/page"
 */
export function parseDynamicUrl(url: string | null | undefined): string | null {
    if (!url) return null

    // Check if it's a dynamic URL format (contains /navigation/)
    const navigationMatch = url.match(/\/navigation\/([a-f0-9]+)/i)
    if (navigationMatch) {
        return `/navigation/${navigationMatch[1]}`
    }

    // Otherwise return as-is (for regular URLs, external links, etc.)
    return url
}
